import WatermarkPanelContainer from './WatermarkPanelContainer';

export default WatermarkPanelContainer;